import Swal, { SweetAlertIcon } from 'sweetalert2'
import { toast } from 'react-toastify'

export interface ConfirmDialogOptions {
  title?: string
  text?: string
  confirmButtonText?: string
  cancelButtonText?: string
  isDestructive?: boolean
  icon?: SweetAlertIcon
}

/**
 * POP UP MODAL KHUSUS UNTUK KONFIRMASI SAJA
 * Menggunakan SweetAlert2 modal dengan tema formal
 */
export const confirmAction = async ({
  title = 'Are you sure?',
  text = "You won't be able to revert this action!",
  confirmButtonText = 'Yes, Proceed',
  cancelButtonText = 'Cancel',
  isDestructive = true,
  icon = 'warning',
}: ConfirmDialogOptions = {}): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      popup: 'formal-swal-popup',
      title: 'formal-swal-title',
      htmlContainer: 'formal-swal-html',
      confirmButton: isDestructive ? 'formal-swal-btn-danger' : 'formal-swal-btn-confirm',
      cancelButton: 'formal-swal-btn-cancel',
      actions: 'formal-swal-actions',
    },
    buttonsStyling: false,
  })

  return result.isConfirmed
}

/**
 * NOTIFIKASI TOAST DI POJOK KANAN ATAS (PERSIS SEPERTI DI GAMBAR USER)
 * Untuk status berhasil, gagal, warning, info — BUKAN modal pop up di tengah!
 */
export const showSuccessAlert = (message: string, detail?: string) => {
  toast.success(detail || message)
}

export const showErrorAlert = (message: string, detail?: string) => {
  toast.error(detail || message)
}

export const showWarningAlert = (message: string, detail?: string) => {
  toast.warning(detail || message)
}

export const showInfoAlert = (message: string, detail?: string) => {
  toast.info(detail || message)
}
